import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const FosterHome = () => {
    const { t } = useTranslation();

    return (
        <div
            className="container-fluid py-5 px-3"
            style={{
                maxWidth: "1200px",
                margin: "0 auto",
                overflowX: "hidden",
            }}
        >
            <div className="row g-5 align-items-start">
                {/* Left column */}
                <div className="col-12 col-lg-6">
                    <h1
                        className="text-center mb-4"
                        style={{ color: "#58c459", fontWeight: 600 }}
                    >
                        {t("foster.subtitle-1")}
                    </h1>

                    <div className="text-center mb-4">
                        <img
                            src="../img/foster-1.jpg"
                            alt="Fostering Animals"
                            className="img-fluid rounded shadow-sm"
                            style={{
                                width: "100%",
                                maxHeight: "400px",
                                objectFit: "cover",
                            }}
                        />
                    </div>

                    <p className="lh-lg">{t("foster.content-1")}</p>
                </div>

                {/* Right column */}
                <div className="col-12 col-lg-6">
                    <h2
                        className="text-center mb-3"
                        style={{ color: "#58c459", fontWeight: 600 }}
                    >
                        {t("foster.subtitle-2")}
                    </h2>
                    <p className="lh-lg">{t("foster.content-2")}</p>
                    <ul className="custom-bullets mb-4">
                        <li>{t("foster.list-1")}</li>
                        <li>{t("foster.list-2")}</li>
                        <li>{t("foster.list-3")}</li>
                    </ul>
                    <p className="lh-lg">{t("foster.content-3")}</p>

                    <h2
                        className="text-center mt-5 mb-3"
                        style={{ color: "#58c459", fontWeight: 600 }}
                    >
                        {t("foster.subtitle-3")}
                    </h2>
                    <p className="lh-lg">{t("foster.content-4")}</p>
                    <ul className="custom-bullets">
                        <li>{t("foster.list-4")}</li>
                        <li>{t("foster.list-5")}</li>
                        <li>{t("foster.list-6")}</li>
                        <li>{t("foster.list-7")}</li>
                    </ul>
                </div>
            </div>

            {/* Contact CTA */}
            <div className="text-center mt-5 border-top pt-4">
                <p className="mb-3">{t("foster.content-5")}</p>
                <NavLink
                    to="/contact"
                    className="btn btn-success px-5 py-2 mt-4"
                    style={{ fontSize: "16px" }}
                >
                    {t("nav.contact")}
                </NavLink>
            </div>
        </div>
    );
};

export default FosterHome;
